import PropTypes from 'prop-types';
import { Radio } from 'lucide-react';
import { cn } from '@/lib/utils';
import { FLIGHT_PREDICTIONS_BRAND } from '@/constants/flightPredictions';

/** The Defera Predictions tag on an early warning (trip page, Home card). */
export default function PredictionsTag({ className }) {
  return (
    <span className={cn('mb-1 flex items-center gap-1.5 text-[10px] sm:text-[11px] uppercase tracking-widest text-amber-200/80', className)}>
      <Radio className="h-3 w-3" aria-hidden="true" />
      {FLIGHT_PREDICTIONS_BRAND}
    </span>
  );
}

PredictionsTag.propTypes = { className: PropTypes.string };
